"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = userFactory;
var _get2 = _interopRequireDefault(require("lodash/get"));
var _isArray2 = _interopRequireDefault(require("lodash/isArray"));
var _mobx = require("mobx");
var _dateFns = require("date-fns");
const dateFormat = 'dd-MM-yyyy HH:mm:ss';

// Custom function to parse the date string
function customParseDate(dateStr) {
  const [day, month, year, hours, minutes, seconds] = dateStr.split(/[- :]/).map(Number);
  // Months are 0-based in JavaScript Date (0 = January, 6 = July)
  return new Date(year, month - 1, day, hours, minutes, seconds);
}
function checkPhoneValue(user) {
  if ((0, _get2.default)(user, 'registrationRequest.phoneRequestedAt')) {
    const phoneRequestedAtDate = (0, _get2.default)(user, 'registrationRequest.phoneRequestedAt');

    // const givenDate = parse(phoneRequestedAtDate, dateFormat);//, new Date());
    if (phoneRequestedAtDate.split) {
      const givenDate = customParseDate(phoneRequestedAtDate);
      const now = new Date();
      const difference = (0, _dateFns.differenceInHours)(now, givenDate);
      if (difference < 24) {
        return (0, _get2.default)(user, 'registrationRequest.phone');
      }
    }
  }
  return (0, _get2.default)(user, 'phone');
}

/**
 * format user response
 * @param {object} user
 * @returns {object} user
 */
function userFactory(user) {
  const phone = checkPhoneValue(user);
  return {
    ...user,
    id: (0, _get2.default)(user, '_id'),
    title: (0, _get2.default)(user, 'Title'),
    firstName: (0, _get2.default)(user, 'FirstName'),
    middleName: (0, _get2.default)(user, 'MiddleName'),
    lastName: (0, _get2.default)(user, 'LastName'),
    primaryEmail: (0, _get2.default)(user, 'email'),
    email: (0, _get2.default)(user, 'registrationRequest.email') || (0, _get2.default)(user, 'email'),
    role: (0, _get2.default)(user, 'role'),
    provider: (0, _get2.default)(user, 'provider'),
    hasVerifiedEmail: (0, _get2.default)(user, 'hasVerifiedEmail'),
    hasVerifiedPhone: (0, _get2.default)(user, 'hasVerifiedPhone'),
    hasVerifiedWhatsApp: (0, _get2.default)(user, 'hasVerifiedWhatsApp'),
    primaryPhone: (0, _get2.default)(user, 'phone'),
    phone,
    whatsapp: (0, _get2.default)(user, 'whatsapp'),
    registrationRequest: (0, _get2.default)(user, 'registrationRequest'),
    registrationHistory: (0, _get2.default)(user, 'registrationHistory')
  };
}